import { Anchor, Box, VStack } from "@bpba/ui-components";
import { SvgData } from "../../model/SvgData";
import { FillSvg } from "../FillSvg";
import { typography, TypographyProps } from "styled-system";
import styled from "styled-components";
import DOMPurify from "dompurify";

const SVG_SIZE = ["60px", "70px", "90px"];

export const IconoItem = (props: { data: SvgData }) => {
  if (!props.data.icono || !props.data.titulo) return <></>;

  return (
    <Anchor
      data={props.data}
      variant={"transparent"}
      display={"flex"}
      aria-label={props.data.titulo}
    >
      <VStack alignItems={"center"}>
        <FillSvg
          width={SVG_SIZE}
          height={SVG_SIZE}
          backgroundColor="secondary.1"
          color="white"
          borderRadius={"50%"}
          padding="0"
        >
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.data.icono!, {
                ADD_ATTR: ["target"],
              }),
            }}
          />{" "}
        </FillSvg>
        <TitleContainer
          mt={["12px", null, null, null, "17px"]}
          justifyContent={"center"}
          fontSize={["14px", "15px"]}
          lineHeight={["18px", "20px"]}
          textAlign="center"
          fontWeight={500}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.data.titulo!, {
                ADD_ATTR: ["target"],
              }),
            }}
          />{" "}
        </TitleContainer>
      </VStack>
    </Anchor>
  );
};

const TitleContainer = styled(Box)<TypographyProps>(typography);
